import * as React from 'react';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import allCountries from './countries';
import { Typography } from '@mui/material';

export default function CountrySelect(props) {

const onSelectOption = (event, value) => {
  //console.log(value);
    props.setValue(value);
}
  
  return (
    <Autocomplete
      id="countrySelect"
      sx={{ width: "100%", margin: 1 }}
      options={allCountries}
      value={props.value}
      autoHighlight
      onChange={onSelectOption}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => {
        const { key, ...optionProps } = props;
        return (
          <Box
            component="li"
            sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
            {...optionProps}
            key={key}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.abbr.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.abbr.toLowerCase()}.png`}
              alt=""
            />
            <Typography variant="body2">{option.name} ({option.abbr})</Typography>
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Project Geography"
          size="small"
          sx={{fieldset: { borderColor: "#888888", mr:2 },
            "& .MuiAutocomplete-endAdornment .MuiIconButton-root": {
              mr: 2
            },
          }} 
                slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: 'new-password', // disable autocomplete and autofill
            },
            inputLabel: {
              sx: {
                fontSize: "0.875rem",
                color: '#555555',
              }
            }
          }}
        />
      )}
    />
  );
}